export enum ScalperLayouts {
    CALL_AND_PUT = "CALL_AND_PUT",
    SPOT_CALL_OR_PUT = "SPOT_CALL_OR_PUT",
    MULTI_CALL_OR_PUT = "MULTI_CALL_OR_PUT",
    SPOT_CALL_AND_PUT = "SPOT_CALL_AND_PUT",
    MULTI_CALL_AND_PUT = "MULTI_CALL_AND_PUT",
    SPOT_MULTI_CALL_AND_PUT = "SPOT_MULTI_CALL_AND_PUT"
}

export enum ScalperDefaultWidgetTypes {
    SPOT_CHART="SPOT_CHART",
    OPTION_CHART="OPTION_CHART",
    MULTISTRIKE_CHART="MULTISTRIKE_CHART",
    CALL_OPTION_CHART="CALL_OPTION_CHART",
    PUT_OPTION_CHART="PUT_OPTION_CHART"
}